.input {
  height: 24px;
}

.revealButton {
  /* the input sets `order: 2`; sit after it so the icon trails the text */
  order: 3;
  flex-shrink: 0;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  margin-left: 4px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  color: var(--ds-grey);
}

.revealButton:hover {
  color: var(--ds-grey-dark);
}
